/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-11 19:46:50
 * @LastEditTime: 2019-09-25 11:00:26
 * @LastEditors: Please set LastEditors
 */

// manulTrack.js

/**
 *
 * @description 由于神策的全埋点中，webclick事件仅支持(a、input、button)三个元素，不能满足其他比如div、img、span、等元素的点击埋点。因此，在项目中如果某一个元素（除a、input、button以外）需要添加全埋点的webclick事件，则在该元素中添加 data-track 属性即可。
 *
 * 通过自定义指令， 当页面中 带有 'v-track' 的元素被插入到dom中的时候， 执行addManulTrack
 *
 */

import Vue from 'vue'
import sa from 'sa-sdk-javascript'
import storage from 'storejs';
import store from './../store'

// 添加事件监听
function addManulTrack (el) {
  console.log(el,'el')
  if (document.addEventListener) {
    el.addEventListener('click', () => {
      /* sa.quick('trackHeatMap', el, {
        ActivityID: userInfo.activityId,
        Activitychannel: store.state.channel
      }) */
      console.log(el)
      console.log(el.getAttribute('data-name'))
      let name = Number(el.getAttribute('data-name'))
      sa.track('v1_ysz_medicalFormulaClick', {
        v1_elementName: name
      })
    })
  } else {
    el.attachEvent('onclick', () => {
      console.log(el)
      let name = Number(el.getAttribute('data-name'))
      sa.track('v1_ysz_medicalFormulaClick', {
        v1_elementName: name
      })
    })
  }
}



Vue.directive('btnClick', {
  inserted: (el) => {
    console.log(el,'eeeeeeee')
    addManulTrack(el)
  }
})


// 添加事件监听
function addClickTrack (el) {
  if (document.addEventListener) {
    el.addEventListener('click', () => {
      sa.quick('trackHeatMap', el)
    })
  } else {
    el.attachEvent('onclick', () => {
      sa.quick('trackHeatMap', el)
    })
  }
}

Vue.directive('track', {
  inserted: (el) => {
    addClickTrack(el)
  }
})


// WEBPACK FOOTER //
// ./src/utils/manulTrack.js